import { ArrowLeft as ArrowLeft_kojaro } from './ArrowLeft.kojaro';
import { ArrowLeft as ArrowLeft_phosphor } from './ArrowLeft.phosphor';
import { ArrowLeft as ArrowLeft_zoomg } from './ArrowLeft.zoomg';
import { ArrowLeft as ArrowLeft_zoomit } from './ArrowLeft.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return ArrowLeft_kojaro;

    case 'zoomg':
      return ArrowLeft_zoomg;

    case 'phosphor':
      return ArrowLeft_phosphor;

    default:
      return ArrowLeft_zoomit;
  }
};

export const ArrowLeft = IconRenderer();
